'use client';

import { Link } from '@/components/Link';
import analytics from '@/services/analytics';
import { useVehicleCompareState } from './VehicleCompareContext';

export interface StickyListActionsProps {
    compareUrl: string;
}

export function StickyListActions({ compareUrl }: StickyListActionsProps) {
    const { categories, categoryCount, clearAll } = useVehicleCompareState();
    const readyToCompare = categoryCount > 1;

    return categories.length > 0 ? (
        <>
            <button className="btn bg-white border-primary text-primary h-13 px-7.5 truncate" onClick={clearAll}>
                Clear all
            </button>
            {readyToCompare ? (
                <Link
                    className="btn btn-primary h-13 truncate w-36.75 md:w-60"
                    href={compareUrl}
                    onClick={() => {
                        analytics.plugins.interactions.trackInteraction({
                            source: 'jucy-website',
                            category: 'compare-now',
                            action: 'click',
                            label: 'Compare now',
                        });
                    }}
                >
                    Compare now
                </Link>
            ) : (
                <button className="btn btn-neutral-disabled h-13 pointer-events-none truncate w-36.75 md:w-60">Add 1 to compare</button>
            )}
        </>
    ) : null;
}
